type Props = {
  avatar: string;
};

export default function AccountUser({ avatar }: Props) {
  return (
    <div>
      <div className="rounded-xl w-20 aspect-square mb-2.5 relative p-1.25">
        <div className="rounded-border" />
        <img src={avatar} alt={avatar} className="w-full h-full object-cover rounded" />
      </div>
    </div>
  );
}
